//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import { useContext } from 'react';
import classNames from 'classnames';
import ReactPropTypes from 'prop-types';

import { FormContext } from './Form';

import * as patch from './PatchFunctions';

export function Radio({
    name,
    id,
    checked,
    value,
    className = "",
    disabled = false,
    readOnly = false,
    title = "",
    onChange,
    ...rest
}) {


    const { 
        initial, current, formId, formDisabled, formReadOnly, defaultOnChange,
    } = useContext(FormContext);

    // Extract the initial value for this named item in the form fields
    const initValue = patch.getPath(initial, name);

    // Use any parameters pass into this field
    const currId = id ? id : `${name}-${value}-${formId}`;
    const currValue = checked ? checked : patch.getPath(current, name);
    const currDisabled = disabled || formDisabled;
    const currReadOnly = readOnly || formReadOnly;

    const radioClass = classNames(
        'form-radio',
        className,
        { 'is-dirty': currValue !== initValue }
    );

    return(
        <div className={radioClass}>
            <input 
                className={`form-radio-input`}
                type={'radio'}
                name={name}
                id={currId}
                value={value}
                checked={currValue === value}
                onChange={(e) => defaultOnChange(e, onChange)}
                disabled={currDisabled}
                readOnly={currReadOnly}
                {...rest}
            />
            <label 
                htmlFor={currId}
                className='form-radio-label'
            >
                {title}
            </label>
        </div>
    );
}

Radio.propTypes = {
    name: ReactPropTypes.string.isRequired,
    type: ReactPropTypes.string,
    value: ReactPropTypes.any,
    onChange: ReactPropTypes.func,
    required: ReactPropTypes.bool,
    disabled: ReactPropTypes.bool,
}

